import { Typography } from "@mui/material";
import { formatCurrency } from "src/helper/convertNum";
import convertCurrency from "src/helper/convertCurrency";
import { TYPE } from "../const/constants";

/** Outbound: + … màu xanh. Inbound: - … màu đỏ. */
export const DEBT_COLOR_OUTBOUND = "#34C759";
export const DEBT_COLOR_INBOUND = "#FF3B30";

export function isInboundInventoryType(inventoryType) {
  if (inventoryType == null || inventoryType === "") return false;
  return String(inventoryType).toLowerCase() === String(TYPE.INBOUND).toLowerCase();
}

/**
 * @param {unknown} amount — số tiền (thường dương từ API)
 * @param {string} [inventoryType] — TYPE.INBOUND | TYPE.OUTBOUND; nếu thiếu → coi như outbound (KD)
 */
export function renderDebtAmountByInventoryType(amount, inventoryType) {
  const n = Number(amount ?? 0);
  const abs = Math.abs(n);
  const inbound = isInboundInventoryType(inventoryType);
  const sign = inbound ? "-" : "+";
  const color = inbound ? DEBT_COLOR_INBOUND : DEBT_COLOR_OUTBOUND;

  return (
    <>
      <Typography
        fontWeight="bold"
        sx={{ color }}
      >
        {sign}
        {formatCurrency(abs)}
      </Typography>
      <Typography
        color="#989898"
        fontSize="8px"
        fontStyle="italic"
      >
        {convertCurrency(n)} đồng
      </Typography>
    </>
  );
}
